<template>
  <v-card
    :style="{
      background: value?.sectionColor?.backGround || 'transparent',
      color: value?.sectionColor?.text || 'inherit',
    }"
    class="pa-4 rounded-1 mt-1"
    flat
  >
    <v-card-title
      :style="{
        color: value?.sectionColor?.text || 'inherit',
      }"
      class="section-title pa-2"
    >
      {{ value.title }}
    </v-card-title>
    <v-card-subtitle
      :style="{
        color: value?.sectionColor?.text || 'inherit',
      }"
      class="ma-0 pa-2"
    >
      {{ value.description }}
    </v-card-subtitle>

    <v-row v-if="items.length > 0" no-gutters>
      <v-col cols="12">
        <v-stepper v-if="showFeedback" v-model="e1" class="transparent" flat>
          <v-card
            class="rounded-lg px-2"
            color="rgba(255, 255, 255, 0.25)"
            outlined
          >
            <v-stepper-header
              class="flex-nowrap overflow-x-auto custom-scrollbar elevation-0"
            >
              <template v-for="i in items.length">
                <v-stepper-step
                  :id="`step-${i}`"
                  :key="`${i}-step`"
                  :complete="e1 > i"
                  :step="i"
                  class="py-2 px-8"
                >
                  <span class="text-no-wrap">سوال {{ i }}</span>
                </v-stepper-step>

                <v-divider v-if="i !== items.length" :key="`divider-${i}`" />
              </template>
            </v-stepper-header>
          </v-card>

          <v-stepper-items>
            <v-stepper-content
              v-for="n in items.length"
              :key="`${n}-content`"
              :step="n"
              class="pt-0 px-3"
            >
              <v-divider />

              <v-card class="mb-12 pa-2 transparent" style="width: 100%" flat>
                <span
                  :style="{ color: value.sectionColor.text }"
                  class="mb-2 d-block"
                  v-html="items[n - 1].question"
                ></span>

                <feedback-type
                  v-model="items[n - 1].value"
                  :type="items[n - 1].type"
                />

                <v-textarea
                  v-if="items[n - 1].description"
                  v-model="items[n - 1].answer"
                  :label="
                    items[n - 1].forceDesc
                      ? 'توضیحات (اجباری)'
                      : 'توضیحات (اختیاری)'
                  "
                  class="mt-4"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  messages="لطفا توضیحات مورد نظر خود را در این فیلد وارد نمایید (حداقل ۳ کاراکتر)"
                  outlined
                  rows="3"
                />
              </v-card>

              <v-btn
                :disabled="n - 1 === 0"
                class="me-2"
                outlined
                @click="e1 = n - 1"
              >
                بازگشت
              </v-btn>

              <v-btn
                :disabled="isNextDisabled(n - 1)"
                color="primary"
                @click="nextStep(n)"
              >
                {{ n < items.length ? "ادامه" : "ثبت" }}
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import feedbackType from "../../businessPage/components/cm/feedbackType.vue";

export default {
  name: "bFeedbackView",

  components: { feedbackType },

  props: {
    value: [Object, Array],
  },

  watch: {
    valueComputed: {
      deep: true,
      handler() {
        this.getInformation();
      },
    },
  },

  data: () => ({
    e1: 1,
    showFeedback: true,
    items: [],
    types: [
      { id: 1, type: "emoji" },
      { id: 2, type: "text" },
      { id: 3, type: "emoji_slider" },
      { id: 4, type: "star" },
      { id: 5, type: "thumbs" },
      { id: 6, type: "slider" },
    ],
  }),

  computed: {
    ...mapState("local", ["qr_id"]),
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  mounted() {
    this.getInformation();
  },

  methods: {
    nextStep(n) {
      if (n === this.items.length) {
        this.storeFeedback();
        this.e1 = 1;
        this.sendAwnser();
      } else {
        this.e1 = n + 1;
      }
    },

    storeFeedback() {
      this.showFeedback = false;
      this.$toast.success("بازخورد شما با موفقیت ثبت شد");
    },

    isNextDisabled(index) {
      const item = this.items[index];
      if (!item) return true;

      const valueIsInvalid = item.value === null || item.value === undefined;
      const descIsRequiredAndEmpty =
        item.description &&
        item.forceDesc &&
        (!item.answer || item.answer.trim().length < 3);

      return !!(valueIsInvalid || descIsRequiredAndEmpty);
    },

    getInformation() {
      this.$api
        .get(this.$qrApi + "/feedback", {
          params: { qr_id: this.qr_id },
        })
        .then(({ data }) => {
          this.items = data.data.map((item) => ({
            id: item.id,
            question: item.question,
            type:
              this.types.find((type) => type.id == item.type_id)?.type || "",
            answer: item.answer,
            description: item.has_description,
            forceDesc: item.description_status === "required",
            value: null,
          }));
          if (data.data?.length === 0) {
            this.setDefaultShow();
          }
        })
        .catch((error) => {
          console.error("Error fetching feedback:", error);
        });
    },

    sendAwnser() {
      let arr = this.items.map((i) => {
        return {
          question_id: i.id,
          type_id: this.types.find((t) => t.type === i.type)?.id || null,
          answer: i.answer ?? "",
          rate: i.value,
        };
      });
      this.$api
        .post(this.$qrApi + "/feedback/answers", arr)
        .then(({ data }) => {
          console.log("Feedback sent successfully:", data);
        })
        .catch((error) => {
          console.error("Error sending feedback:", error);
        });
    },

    setDefaultShow() {
      let name = this.$route.name;
      if (name === "qr.name.id.editFeedback" || name === "qr.feedback") {
        this.items = [...this.value.items];
      }
    },
  },
};
</script>

<style scoped>
.section-title {
  position: relative;
}

.section-title:before {
  content: "";
  width: 150px;
  height: 1px;
  background: var(--v-primary-base);
  position: absolute;
  bottom: 0;
  right: 0;
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}
</style>
